/**
 * Liga MX Theme Configuration
 * Brand colors: Green (#006847), Red (#CE1126), White - Mexican flag colors
 */

const ligamxTheme = {
    // Client identification
    clientId: 'ligamx',
    clientName: 'Liga MX',

    // Logo configuration - TODO: Add Liga MX logos
    logos: {
        primary: require('../../components/Login/images/ligamx.png'), // Replace with ligamx logo
        primaryHeight: '85px',
        secondary: require('../../components/Login/images/theteam.png'),
        secondaryHeight: '52px',
    },

    // Channel colors and gradients - Mexican flag palette (lighter gradients)
    channels: {
        social: {
            color: '#006847',
            gradient: ['#00C853', '#00A86B'],
        },
        digital: {
            color: '#CE1126',
            colorHex: '#CE1126',
            gradient: ['#FF6B6B', '#E63946'],
        },
        highlights: {
            color: '#FFB800',
            gradient: ['#FFD54F', '#FFC107'],
        },
        linear: {
            color: '#4DD0E1',
            colorAlt: '#00897B',
            gradient: ['#80DEEA', '#4DD0E1'],
        },
        tv: {
            color: '#00897B',
            gradient: ['#4DB6AC', '#26A69A'],
        },
        invenue: {
            color: '#00897B',
            gradient: ['#4DB6AC', '#26A69A'],
        },
        ooh: {
            color: '#7B1FA2',
            gradient: ['#BA68C8', '#AB47BC'],
        },
        sponsorship: {
            color: '#8BC34A',
            gradient: ['#AED581', '#8BC34A'],
        },
    },

    // Gradient card text color
    gradientCardText: 'black',

    // Background colors - Green-tinted dark theme
    backgrounds: {
        page: '#0A120A',
        loginPage: 'rgb(10, 20, 12)',
        panel: '#0F1A12',
        panelDark: 'hsl(140 30% 7%)',
        panelMid: 'hsl(140 20% 12%)',
        panelAlt: 'hsl(140 20% 16%)',
        panelLight: 'hsl(140 15% 22%)',
        modal: '#1A2A1D',
    },

    // Text colors
    text: {
        primary: 'white',
        secondary: '#8BC34A',
        highlight: '#00E676',
        onLight: '#004D34',
        link: '#4DD0E1',
        wheat: '#C8E6C9',
    },

    // Button colors - must use Semantic UI color names
    buttons: {
        primary: 'green',
        dashboard: 'green',
        viz3d: 'teal',
        rawdata: 'grey',
        apply: 'green',
        save: 'olive',
        reset: 'red',
        refresh: 'teal',
    },

    // Accent colors - Red on green for high contrast (primary must be Semantic UI color name for Label)
    accents: {
        primary: 'red',  // Mexican flag red, high contrast on green (matches brand)
        secondary: '#CE1126',
        tertiary: '#FFB800',
        tab1: '#00E676',
        tab2: '#CE1126',
        tab3: '#FFB800',
    },

    // Navigation colors
    navigation: {
        background: '#0A120A',
        iconColor: '#4DB6AC',
        iconActiveColor: '#00E676',
        iconHighlight: '#CE1126',
    },

    // Label colors - must use Semantic UI color names for ribbon to work
    labels: {
        brand: 'orange',   // Avg label - warm color
        asset: 'red',      // Progress bar - Mexican flag red, different from brand
        channel: 'teal',
        comparison: 'green',
        ribbon: 'green',
    },

    // Shadow styles - Green tint
    shadows: {
        card: 'hsl(140 20% 20%) 0 0 4px',
        cardLarge: 'hsl(140 20% 20%) 0 0 8px',
        image: '#020502 9px 10px 20px 2px',
    },

    // Gauge/Speedometer colors
    gauge: {
        stages: [
            [0.09, '#CE1126'],
            [0.25, '#E63946'],
            [0.45, '#FFB800'],
            [0.7, '#4DD0E1'],
            [1, '#00E676'],
        ],
        text: '#fff',
        detail: '#1A2A1D',
        shadow: '#00E676',
    },

    // Table row color palette - Green shades
    tableRows: [
        '#0F1A12',
        '#1A2E1F',
        '#254A2E',
        '#006847',
        '#2E7D50',
        '#388E5C',
        '#1E6B4A',
        '#2A7B58',
        '#1B5D3F',
        '#2C5A42',
        '#3A6B4F',
        '#285B40',
        '#1E4D35',
    ],

    // Form element colors
    forms: {
        loginFormBackground: '#0A120A',
        loginFormOpacity: '0.85',
        dropdownBackground: '#006847',
        dropdownText: 'white',
        inputBackground: '#1A2A1D',
        inputText: '#00E676',
    },

    // Progress bar colors - orange fill on green for high contrast
    progressBar: {
        background: 'hsl(140 15% 22%)',
        fill: '#FF8C00',  // Orange for high contrast (was green)
        tiny: '#1A2A1D',
    },

    // Scrollbar colors
    scrollbar: {
        track: '#0F1A12',
        thumb: '#1A2A1D',
    },

    // Chart-specific colors
    charts: {
        axisLabel: '#7A9A7D',
        axisLine: 'white',
        tooltipBackground: '#1A2A1D',
    },
};

export default ligamxTheme;
